import dlItems from './dlItems';

const root = {
	dlItems
};

export default root;
